<template>
  <div>
      <base-drawer :open="open" :close="close" title="Alterar senha" @onClose="clearPasswords">
        <base-card>
          <p class="password-text mb_25">Informe os dados para trocar sua senha</p>
          <custom-form ref="passwordForm">
            <password-input :label="StringLanguage.currentPassword" v-model="currentPassword" />
            <double-pw-input :label="StringLanguage.newPassword" :labelConfirm="StringLanguage.repeatNewPassword" v-model="dbPassword" class="mb_10" />
          </custom-form>
        </base-card>
        <template v-slot:footer>
          <base-button text="Alterar" @click="updatePassword" class="w-100" />
        </template>
      </base-drawer>
  </div>
</template>
<script>

import BaseButton from "@/components/Button";
import BaseDrawer from "@/components/Drawer";
import BaseCard from "@/components/Card";
import CustomForm from "@/containers/Form";
import PasswordInput from '@/containers/Inputs/PasswordInput';
import DoublePwInput from '@/containers/Inputs/DoublePwInput';

export default {
  components: {
    BaseDrawer,
    BaseButton,
    BaseCard,
    CustomForm,
    PasswordInput,
    DoublePwInput
  },
  props: {
    open: { type: Boolean, default: false },
    close: { type: Boolean, default: false }
  },
  data() {
      return {
        currentPassword: "",
        dbPassword: {
          password: "",
          confirmPassword: "",
        }
      }
  },
  methods: {
    updatePassword() {
      //validar erros, se houver dá return false;
      this.$refs.passwordForm.validateInputs();
      if (this.$refs.passwordForm.messages.length) {
        return false;
      }

      this.$emit('updatePassword', this.currentPassword, this.dbPassword);
    },
    clearPasswords() {
      this.currentPassword = "";
      this.dbPassword = {
        password: "",
        confirmPassword: "",
      }
    }
  }
};
</script>
<style scoped>
.password-text {
  text-align: left;
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: #999999;
}

</style>